import {
  AudioLines,
  Copy,
  Crop,
  Ellipsis,
  Images,
  ScanLine,
  SmilePlus,
  TimerReset,
  WandSparkles,
  type LucideIcon,
} from "lucide-react";

import type { FeedbackIconKey } from "./feedbackTaxonomy";

const ICONS: Record<FeedbackIconKey, LucideIcon> = {
  crop: Crop,
  "wand-sparkles": WandSparkles,
  "smile-plus": SmilePlus,
  "scan-line": ScanLine,
  copy: Copy,
  images: Images,
  "timer-reset": TimerReset,
  "audio-lines": AudioLines,
  ellipsis: Ellipsis,
};

export const FeedbackCategoryIcon = ({
  iconKey,
  className = "size-4",
}: {
  iconKey: FeedbackIconKey;
  className?: string;
}) => {
  const Icon = ICONS[iconKey];
  return <Icon aria-hidden="true" className={className} />;
};
